import React, { useState, useEffect } from 'react';
import api from '../api';
import DashboardNav from './DashboardNav';
import LoadingSpinner from './LoadingSpinner';

import './ApprovalRequests.css';

const ApprovalRequests = () => {
  const [requests, setRequests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');
  const [actionLoading, setActionLoading] = useState({});

  useEffect(() => {
    const fetchApprovalRequests = async () => {
      try {
        setIsLoading(true);
        setError('');
        const token = localStorage.getItem('token');
        const res = await api.get('/approval-requests', {
          headers: {
            'x-auth-token': token,
          },
        });
        setRequests(res.data);
      } catch (err) {
        console.error('Error fetching approval requests:', err.response ? err.response.data : err.message);
        setError('Failed to load approval requests. Please try again.');
      } finally {
        setIsLoading(false);
      }
    };
    fetchApprovalRequests();
  }, []);

  const handleApprove = async (id) => {
    try {
      setActionLoading(prev => ({ ...prev, [id]: true }));
      const token = localStorage.getItem('token');
      await api.put(`/approval-requests/${id}/approve`, {}, {
        headers: {
          'x-auth-token': token,
        },
      });
      // Update the status in the local state
      setRequests(requests.map(req => req._id === id ? { ...req, status: 'Approved' } : req));
    } catch (err) {
      console.error('Error approving request:', err.response ? err.response.data : err.message);
    } finally {
      setActionLoading(prev => ({ ...prev, [id]: false }));
    }
  };

  const handleReviewEdit = (id) => {
    // Implement review/edit logic, e.g., navigate to a detail page or open a modal
    console.log('Review/Edit request with ID:', id);
  };

  return (
    <div className="approval-requests-container">
      <header className="approval-requests-header">
        <h1>Temporary Stop Change Requests</h1>
        <DashboardNav />
      </header>
      
      {error && (
        <div className="error-message">
          <p>{error}</p>
          <button onClick={() => window.location.reload()}>Retry</button>
        </div>
      )}
      
      <div className="requests-list">
        {isLoading ? (
          <LoadingSpinner size="medium" message="Loading approval requests..." />
        ) : (
          <>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Requested</th>
                  <th>Student</th>
                  <th>Parent</th>
                  <th>Parent's Description</th>
                  <th>Duration</th>
                  <th>Reason</th>
                  <th>Status</th>
                  <th>Admin Notes/Temp. Stop</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {requests.length > 0 ? (
                  requests.map((request) => (
                    <tr key={request._id}>
                      <td>{new Date(request.requestedAt).toLocaleString()}</td>
                      <td>{request.student ? request.student.name : 'N/A'}</td>
                      <td>{request.parent ? request.parent.name : 'N/A'}</td>
                      <td>{request.parentDescription}</td>
                      <td>{request.duration}</td>
                      <td>{request.reason}</td>
                      <td>{request.status}</td>
                      <td>{request.adminNotes || 'N/A'}</td>
                      <td>
                        {request.status === 'Pending' && (
                          <button 
                            onClick={() => handleApprove(request._id)} 
                            className={`approve-button ${actionLoading[request._id] ? 'btn-loading' : ''}`}
                            disabled={actionLoading[request._id]}
                          >
                            {actionLoading[request._id] ? (
                              <>
                                <LoadingSpinner size="small" message="" />
                                Approving...
                              </>
                            ) : (
                              'Approve'
                            )}
                          </button>
                        )}
                        <button onClick={() => handleReviewEdit(request._id)} className="review-edit-button">Review/Edit</button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{ textAlign: 'center', padding: '20px' }}>
                      No approval requests found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </>
        )}
      </div>
    </div>
  );
};

export default ApprovalRequests;
